import { PaymentMethod } from "@/services/core-api-adapter";
import VoucherOrderSummary from ".";

export default function VoucherOrderSummaryExamples() {
  return (
    <VoucherOrderSummary
      voucherPaymentReceipt={{
        showReceipt: true,
        paymentSuccess: true,
        status: "ASSIGNED",
        paymentUtcDateTime: "2025-05-05T10:50:50.819942+00:00",
        voucherCode: "QQTE-7238-PTMM",
        voucherTypeName: "Blood test",
        voucherTypeDescription: "",
        paymentAmount: 36900,
        originalAmount: 67400,
        discountAmount: 30500,
        isDiscountApplied: true,
        currencyCode: "ZAR",
        transactionReferenceNumber: "MR0508199379",
        unuMerchantId: "1907c4c7-5fca-4761-a39e-ccda4e7bd58c",
        cardNumber: "44838500******71",
        voucherSubTypeName: "Blood Test",
        voucherSubTypeDescription: "Includes basic blood analysis",
        paymentMethod: PaymentMethod.EcentricEFT,
        oneVoucherDetails: null,
      }}
      onViewReceiptClick={() => {
        console.log("View Receipt Clicked");
      }}
      onBackButtonClick={() => {
        console.log("Back Clicked");
      }}
      onShareVoucherClick={() => {
        console.log("Share Clicked");
      }}
      onSaveToProfileClick={() => {
        console.log("Save to Profile Clicked");
      }}
      isDownloadingVoucherFile={false}
    />
  );
}
